import { ResolveFn } from '@angular/router';
import {inject} from '@angular/core';
import {RenderStrategy} from '../../enums/render-strategy';
import {EventService} from '../event.service';
import {Subscription} from 'rxjs';

export const eventIndexResolver: ResolveFn<Promise<void | Subscription>> = () => {
  return inject(EventService).resolveIndex(RenderStrategy.PREFER_SERVER);
};
